import { useMemo } from "react";
import { useSelector } from "react-redux";
import { paginatedEquipmentSelector } from "Venues/state";
import { IEquipmentCategory } from "Venues/types";
import { getStageEquipmentKey, usePagination } from "Venues/utils";

export const useSelectStageEquipment = (stageId: string, category: IEquipmentCategory) => {
  const paginationKey = useMemo(() => getStageEquipmentKey(stageId, category), [stageId, category]);
  const pagination = usePagination(paginationKey);
  const equipment = useSelector(paginatedEquipmentSelector(pagination));

  return { paginationKey, pagination, equipment };
};
